<template>
  <AppModal :title="tt('general.mail_recipient_scope_title', 'Mail Gönderimi')"
            :visible.sync="visible"
            class="mail-recipient-scope-modal"
            width="520px"
  >
    <p v-if="mailTypeText" class="mail-recipient-scope-modal__mail-type">
      {{ mailTypeText }}
    </p>
    <p class="mail-recipient-scope-modal__question">
      {{
        tt(
          'general.mail_recipient_scope_question',
          'Mail sistemdeki tüm kullanıcılara mı yoksa sadece seçili kullanıcılara mı gönderilsin?'
        )
      }}
    </p>

    <template #footer>
      <button class="btn btn-success mail-recipient-scope-modal__button" type="button" @click="select('all')">
        <i class="uil-users-alt"></i>
        {{ tt('general.mail_recipient_scope_all', 'Tüm Kullanıcılar') }}
      </button>
      <button class="btn btn-secondary mail-recipient-scope-modal__button" type="button" @click="select('selected')">
        <i class="uil-check-square"></i>
        {{ tt('general.mail_recipient_scope_selected', 'Sadece Seçili Kullanıcılar') }}
        <span v-if="selectedCount">({{ selectedCount }})</span>
      </button>
    </template>
  </AppModal>
</template>

<script>
import AppModal from "@/view/components/ui/AppModal.vue";

export default {
  name: "MailRecipientScopeModal",
  components: { AppModal },
  props: {
    // Modalda hangi mailin gönderileceğini belirtmek için gösterilen başlık
    mailTypeText: {
      type: String,
      default: ""
    },
    selectedCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    // Çeviriler API'den geldiği için eksik anahtarlarda fallback metin kullanılır
    tt(key, fallback) {
      if (this.$te && this.$te(key)) {
        const translated = this.$t(key);
        if (translated && translated !== key) return translated;
      }
      return fallback;
    },
    // scope: 'all' -> sistemdeki tüm kullanıcılar, 'selected' -> sadece işaretli kullanıcılar
    select(scope) {
      this.$emit('scope-selected', scope);
      this.hide();
    },
    // show()/hide() KORUNDU: Users/index.vue modalı `$refs` uzerinden aciyor
    // (`this.$refs.mailScopeModal.show()`), AppModal'a gecerken o cagri
    // noktasini degistirmek gerekmedi.
    show() {
      this.visible = true;
    },
    hide() {
      this.visible = false;
    }
  }
};
</script>

<style scoped>
.mail-recipient-scope-modal__mail-type {
  margin-bottom: 8px;
  font-weight: 600;
}

.mail-recipient-scope-modal__question {
  margin: 0;
}

/* inline-flex: ikon + uzun etiket ("Sadece Secili Kullanicilar (12)")
   ortali kalsin ve dar butonda sarabilsin. */
.mail-recipient-scope-modal__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: normal;
  text-align: center;
}

.mail-recipient-scope-modal__button i {
  flex-shrink: 0;
}

/* AppModal mobilde genisligi, gövde padding'ini ve kapatma dugmesinin
   dokunma hedefini kendisi hallediyor (AppModal.vue:243). Burada yalnizca
   footer'a ozgu yigin duzeni kaliyor. */
@media (max-width: 768px) {
  .mail-recipient-scope-modal ::v-deep .app-modal-footer {
    /* column-reverse: birincil eylem ("Tüm Kullanıcılar") en altta,
       basparmaga en yakin yerde kalir */
    flex-direction: column-reverse;
    padding: 16px;
  }

  .mail-recipient-scope-modal__button {
    width: 100%;
    /* MOBILE_UI_GUIDELINES: primary buton min 48px */
    min-height: 48px;
    font-size: 16px;
    line-height: 1.4;
  }
}
</style>
